import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import React from 'react'
import Text from '@eversports/react-components/primitives/Text'
import { Theme } from '@eversports/react-components/design-tokens/theme'
import { makeStyles } from '@mui/styles'
import { Localized } from '../../localization/react'
import { Interval, Promotion } from '../../typings/Product'
import Price from '../../typings/Price'

const useStyles = makeStyles((theme: Theme) => ({
  membershipPromotionSummary: {
    backgroundColor: theme.palette.lightGray,
    padding: 8,
    borderRadius: 4,
    width: 'fit-content',
  },
}))

interface Props {
  promotion: Promotion
  paymentInterval: Interval
  recurringPrice: Price
}

const MembershipPromotionInfo: React.FC<React.PropsWithChildren<Props>> = ({
  promotion,
  paymentInterval,
  recurringPrice,
}) => {
  const classes = useStyles()

  return (
    <Text size="small" className={classes.membershipPromotionSummary}>
      <Localized
        id="membership-promotion-summary"
        params={{
          promotionalPrice: <MonetaryValue value={promotion.price.value} currencyCode={promotion.price.currency} />,
          promotionalPeriod: (
            <Localized
              id="interval"
              params={{
                intervalValue: promotion.period.value,
                intervalType: promotion.period.type as any,
              }}
            />
          ),
          paymentInterval: (
            <Localized
              id="interval"
              params={{
                intervalValue: paymentInterval.value,
                intervalType: paymentInterval.type as any,
              }}
            />
          ),
          recurringPrice: <MonetaryValue value={recurringPrice.value} currencyCode={recurringPrice.currency} />,
        }}
      />
    </Text>
  )
}

export default MembershipPromotionInfo
